// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__CDic-","title":"FrontImage_title__251ha"};